module.exports = __webpack_public_path__ + "img/jiantouTop.280d12a6.svg";